// src/components/SEO.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
}

export const SEO: React.FC<SEOProps> = ({ title, description, url, image }) => {
  const siteUrl = 'https://lastminutewellness.ca';
  const metaTitle = title || 'Last Minute Wellness';
  const metaDescription = description || 'Book last-minute health and wellness appointments online.';
  const metaUrl = url || siteUrl;
  const metaImage = image || `${siteUrl}/banner.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaUrl} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:image" content={metaImage} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Last Minute Wellness",
          url: siteUrl,
          logo: `${siteUrl}/favicon.ico`,
        })}
      </script>
    </Helmet>
  );
};